import React, { ReactNode } from 'react';
import { SingleMenuStep, SingleMenuStepProps } from './SingleStep/SingleMenuStep';

interface Props {
  title: string;
  subTitle: string;
  AdditionalComponent?: ReactNode;
  singleSteps: SingleMenuStepProps[];
  onSelectStep: (stepName: string) => void;
}

export const StepsMenu: React.FC<Props> = ({ title, onSelectStep, singleSteps, subTitle }) => {
  return (
    <div className="flex flex-col flex-1 grow bg-white h-full  shadow-custom  ">
      <div className=" flex justify-between px-[1.5rem] pt-[1.625rem] border-b border-gray-100">
        <div>
          <h2 className="text-[1.125rem] leading-4 lg:block xl:block sm:hidden md:hidden ">{title}</h2>
          <h4 className="text-xs leading-4 opacity-80 text-gray-700 pb-2 lg:block xl:block sm:hidden md:hidden">
            {subTitle}
          </h4>
        </div>
      </div>
      <div className="overflow-y-auto">
        {singleSteps.map((step) => (
          <SingleMenuStep
            key={step.id}
            id={step.id}
            stepName={step.stepName}
            stepDisplayName={step.stepDisplayName}
            stepStatus={step.stepStatus}
            toolTipText={step.toolTipText || step.stepDisplayName}
            isSelected={step.isSelected}
            onClick={() => onSelectStep(step.stepName)}
          />
        ))}
      </div>
    </div>
  );
};
